/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import Styles from './Renegociacao25.css';
import Renegociacao25Blog from '@/components/organisms/Renegociacao25Blog';
import FaqLPs25 from '@/components/molecules/FaqLPs25';
import Renegociacao25Banner from '@/components/organisms/Renegociacao25Banner';
import Renegociacao25Entenda from '@/components/organisms/Renegociacao25Entenda';
import Renegociacao25Vantagens from '@/components/organisms/Renegociacao25Vantagens';
import Renegociacao25Confira from '@/components/organisms/Renegociacao25Confira';
import Renegociacao25DDA from '@/components/organisms/Renegociacao25DDA';
import Renegociacao25Canais from '@/components/organisms/Renegociacao25Canais';
import Renegociacao25Parceiros from '@/components/organisms/Renegociacao25Parceiros';

function Renegociacao25({ show }) {
  return (
    <>
      <div id="page-renegociacao-financiamentos" className={show ? 'show' : ''}>
        <Renegociacao25Entenda />
        <Renegociacao25Vantagens />
        <Renegociacao25Confira />
        <Renegociacao25DDA />
        <Renegociacao25Canais />
        <Renegociacao25Parceiros />
        <style jsx>{Styles}</style>
      </div>
    </>
  );
}

export default Renegociacao25;
